<template>
  <first-trial :firstLogin="checkFirstTrial" :trial="true"></first-trial>

</template>

<script>
import firstTrial from '@/views/v2/pages/trial/FirstTrial.vue'

export default {
  components:{
   firstTrial,
  },
  data() {
    return {
      checkFirstTrial: true,
      activeConfirm : true,
    }
  },
name: "TrialDashboard"
}
</script>

<style scoped>

</style>
